import { Box, Pagination as MaterialPagination } from "@mui/material";

const Pagination = ({
  className = "",
  total = 0,
  currentPage,
  setCurrentPage,
  itemsPerPage,
}) => {
  const totalPages = Math.ceil(total / itemsPerPage);

  return (
    <Box className={className}>
      {totalPages > 1 && (
        <MaterialPagination
          count={totalPages}
          page={currentPage}
          onChange={(event, value) => setCurrentPage(value)}
          variant="outlined"
          shape="rounded"
        />
      )}
    </Box>
  );
};

export default Pagination;
